<template>
	<svg xmlns="http://www.w3.org/2000/svg">
		<use :href="xlink" />
	</svg>
</template>

<script>
import svg from '@/assets/icons.svg'

export default {
	name: 'icon',
	props: {
		name: String,
		source: {
			type: String,
			default: svg
		}
	},
	computed: {
		xlink() {
			return `${this.source}#${this.name}`
		}
	}
}
</script>

<style scoped>
svg {
	max-width: 100%;
	max-height: 100%;
}
</style>
